import React, { useRef, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { sectionMargins } from '../styles';
import { Container } from './ui';

const StyledCarousel = styled.section`
  ${sectionMargins()};
`;

const StyledMicroCombo = styled.div`
  width: 100%;
`;

const TrustpilotWidget = ({ type, theme = 'light', isTest }) => {
  const widget = useRef(null);

  const [showWidget, setShowWidget] = useState(false);

  useEffect(() => {
    setShowWidget(true);

    if (
      showWidget === true &&
      typeof window !== 'undefined' &&
      window.Trustpilot
    ) {
      window.Trustpilot.loadFromElement(widget.current, true);
    }
  }, [showWidget]);

  return (
    <>
      <Helmet>
        <script
          type="text/javascript"
          src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
          async
        ></script>
      </Helmet>
      {showWidget &&
        (type === 'mini' ? (
          <div
            ref={widget}
            className={`trustpilot-widget${
              isTest ? ' trustpilot-widget-test' : ''
            }`}
            data-locale="en-GB"
            data-template-id="53aa8807dec7e10d38f59f32"
            data-businessunit-id="4bdc20420000640005058e9e"
            data-style-height="80px"
            data-style-width="120px"
            data-theme={theme}
            data-stars="1,2,3,4,5"
            data-no-reviews="hide"
            data-scroll-to-list="true"
            data-allow-robots="true"
            data-text-align="right"
          >
            <a
              href="https://uk.trustpilot.com/review/www.spaseekers.com"
              target="_blank"
              rel="noopener"
            >
              Trustpilot
            </a>
          </div>
        ) : type === 'carousel' ? (
          <StyledCarousel>
            <Container>
              <div
                ref={widget}
                className={`trustpilot-widget${
                  isTest ? ' trustpilot-widget-test' : ''
                }`}
                data-locale="en-GB"
                data-template-id="53aa8912dec7e10d38f59f36"
                data-businessunit-id="4bdc20420000640005058e9e"
                data-style-height="140px"
                data-style-width="100%"
                data-theme={theme}
                data-stars="4,5"
                data-review-languages="en"
                data-font-family="Quicksand"
                data-text-color="#000000"
              >
                <a
                  href="https://uk.trustpilot.com/review/www.spaseekers.com"
                  target="_blank"
                  rel="noopener"
                >
                  Trustpilot
                </a>
              </div>
            </Container>
          </StyledCarousel>
        ) : type === 'micro-star' ? (
          <div
            ref={widget}
            className={`trustpilot-widget${
              isTest ? ' trustpilot-widget-test' : ''
            }`}
            data-locale="en-GB"
            data-template-id="5419b732fbfb950b10de65e5"
            data-businessunit-id="4bdc20420000640005058e9e"
            data-style-height="24px"
            data-style-width="100%"
            data-theme={theme}
            data-font-family="Quicksand"
            data-text-color="#000000"
          >
            <a
              href="https://uk.trustpilot.com/review/www.spaseekers.com"
              target="_blank"
              rel="noopener"
            >
              Trustpilot
            </a>
          </div>
        ) : type === 'micro-combo' ? (
          <StyledMicroCombo
            ref={widget}
            className={`trustpilot-widget${
              isTest ? ' trustpilot-widget-test' : ''
            }`}
            data-locale="en-GB"
            data-template-id="5419b6ffb0d04a076446a9af"
            data-businessunit-id="4bdc20420000640005058e9e"
            data-style-height="20px"
            data-style-width="100%"
            data-theme={theme}
            data-font-family="Quicksand"
          >
            <a
              href="https://uk.trustpilot.com/review/www.spaseekers.com"
              target="_blank"
              rel="noopener"
            >
              Trustpilot
            </a>
          </StyledMicroCombo>
        ) : (
          ''
        ))}
    </>
  );
};

export default TrustpilotWidget;
